import { Route } from "react-router-dom";
// import RegisterUser from "@view/user/registration/RegisterUser";
import RegistrationUser from "@view/user/registration/RegistrationUser";
import LinkWorker from "@view/user/registration/LinkWorker";
import PtoPage from "@view/user/PtoPage";

// export a fragment of <Route> elements
export default function RegistrationRoutes() {
  return (
    <>
      {/* <Route path="/register" element={<RegisterUser />} /> */}
      <Route
        path="/registration/:encryptedData"
        element={<RegistrationUser />}
      />
      <Route path="/confirm/user/:userId" element={<LinkWorker />} />
      <Route
        path="/confirm/user/:userId/:contractorId"
        element={<LinkWorker />}
      />
      <Route
        path="/confirm/user/temp/:email/:contractorId"
        element={<LinkWorker />}
      />
      <Route path="/dev/confirm" element={<LinkWorker />} />
      <Route path="/ptoRequests" element={<PtoPage />} />
    </>
  );
}
